/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Orders/Filters/StatusChooser/Error"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<Label
  viewPath={`${viewPath}/Label`}
 text="statuses"
 fontSize={8}
 marginBottom={dtSpaceXs}
 marginTop={dtSpaceS}
 marginLeft={10}
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={dtSpaceXs}
 text="Something went wrong trying to fetch statuses"
/>
{children}
</React.Fragment>)
}